import React from 'react'

const PeopleFeatures = () =>
  <div className="page feature">
    <h1>People Management</h1>
  </div>

export default PeopleFeatures
